import {
  Dialog,
  Popover,
  RadioGroup,
  Switch,
  Transition,
} from "@headlessui/react";
import { Icon } from "@iconify/react";
import { Fragment, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { Range, getTrackBackground } from "react-range";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  createUserProgram,
  getCouponDetails,
  getEmailExists
} from "../../api/api";
import congrats from "../../assets/gifs/congrats.gif";
import ic_close from "../../assets/icons/ic_close.svg";
import { useAuthContext } from "../../context/AuthContext";
import {
  WhiteLinearGradientDarkPlain,
  numberToWords,
  validPhone
} from "../../utils/Utils";
import CustomDialog from "../basic/Dialog";
import IconButton from "../basic/IconButton";
import { CuratingPlaylist, OtpVerification } from "./CreateAccountDialog";

import "react-datepicker/dist/react-datepicker.css";
import healthyLife from "../../assets/images/healthy_life.png";

// export function Stepper({ maxStep, currentStep }) {
//   const Indicator = ({ active, text, align }) => (
//     <div className={`flex flex-col `}>
//       <p
//         className={`${
//           active ? "text-white" : "text-new-gray"
//         } flex flex-row items-center gap-3  text-xs md:text-base`}
//       >
//         <span>
//           <Icon icon="mdi:tick" className="md:h-6 md:w-6" />
//         </span>
//         {text}
//       </p>
//       <div
//         className={` rounded-full h-[10px] md:h-[20px] w-[10px] md:w-[20px] p-1 shadow-md shadow-black/20 drop-shadow-md ${
//           active ? "bg-primary-orange" : "bg-new-gray"
//         }`}
//       ></div>
//     </div>
//   );

//   return (
//     <div className="w-full md:w-1/2 justify-center mt-10">
//       <div className="relative flex items-center w-full">
//         <div className=" absolute w-5/6 mr-10  mt-6 bg-new-gray h-[1px] rounded-md flex items-center ">
//           <div
//             style={{
//               width: `${(currentStep / maxStep) * 100}%`,
//               // background: "linear-gradient(90deg, #34E130 0%, #30A1E1 95.95%)",
//               transition: "width 500ms",
//             }}
//             className=" h-[1px] rounded-md bg-primary-orange"
//           ></div>
//         </div>
//         <div className="absolute w-full  z-1 flex flex-row justify-between">
//           <Indicator active={currentStep >= 0} align="start" text="ABOUT YOU" />
//           <Indicator
//             active={currentStep >= 1}
//             align="center"
//             text="FITNESS & GOALS"
//           />
//           <Indicator active={currentStep >= 2} align="end" text="JOURNEY" />
//         </div>
//       </div>
//     </div>
//   );
// }

export function RegistrationStep1({
  isRegister,
  name,
  setName,
  email,
  setEmail,
  password,
  mobile,
  setMobile,
  setPassword,
  gender,
  setGender,
  height,
  setHeight,
  weight,
  setWeight,
  heightUnit,
  setHeightUnit,
  weightUnit,
  setWeightUnit,
  dob,
  setDob,
  register,
  coupon,
  setCoupon,
  registerThrough,
  wasBackPressed,
  onClickNext,
}) {
  const [showOtp, setShowOtp] = useState(false);
  const [showCouponApplied, setShowCouponApplied] = useState(false);
  const [passwordInputType, setPasswordInputType] = useState("password");
  const [feet, setFeet] = useState(Math.floor(height / 2.54 / 12));
  const [inch, setInch] = useState(
    (height / 2.54 - 12 * Math.floor(height / 2.54 / 12)).toFixed(2)
  );
  const [extraTrailDays, setExtraTrailDays] = useState(0);
  const [bmi, setBMI] = useState("");
  const [bmr, setBMR] = useState("");
  const [healthStatus, setHealthStatus] = useState();

  // Calculate BMI
  function calculateBMI() {
    const heightInCm = parseInt(height);
    const weightInKg = parseInt(weight);

    if (isNaN(heightInCm) || isNaN(weightInKg)) {
      setBMI("");
    } else {
      const bmiValue = weightInKg / (heightInCm / 100) ** 2;
      setBMI(bmiValue.toFixed(1));
    }
  }

  // Claculate BMR
  function calculateBMR() {
    const weightInKg = parseInt(weight);
    const heightInCm = parseInt(height);

    if (isNaN(weightInKg) || isNaN(heightInCm)) {
      setBMR("");
    } else {
      const dobTimestamp = Date.parse(dob);
      const ageInYears =
        (Date.now() - dobTimestamp) / (1000 * 60 * 60 * 24 * 365.25);
      console.log("Age acc to dob: " + ageInYears);

      let bmrValue = 0;
      if (gender === "male") {
        bmrValue =
          88.36 + 13.4 * weightInKg + 4.8 * heightInCm - 5.7 * ageInYears;
      } else if (gender === "female") {
        bmrValue =
          447.6 + 9.2 * weightInKg + 3.1 * heightInCm - 4.3 * ageInYears;
      }
      setBMR(bmrValue.toFixed(0));
    }
  }

  // Health Status
  function getHealthCondition() {
    if (bmi === "") {
      return "";
    } else if (bmi < 18.5) {
      return "Underweight";
    } else if (bmi >= 18.5 && bmi < 24.9) {
      return "Healthy weight";
    } else if (bmi >= 24.9 && bmi < 29.9) {
      return "Overweight";
    } else {
      return "Obese";
    }
  }
  // function getHealthCondition() {
  //   if (bmi === "") {
  //     return "";
  //   } else if (bmi < 18.5) {
  //     return setHealthStatus("Underweight");
  //   } else if (bmi >= 18.5 && bmi < 25) {
  //     return setHealthStatus("Healthy");
  //   } else if (bmi >= 25 && bmi < 30) {
  //     return setHealthStatus("Overweight");
  //   } else {
  //     return setHealthStatus("Obese");
  //   }
  // }

  useEffect(() => {
    calculateBMI();
    calculateBMR();
    getHealthCondition();
  }, [gender, weight, height]);

  // Auto-Fill by Session-Storage
  const autoFirstName = sessionStorage.getItem("first_name");
  const autoLastName = sessionStorage.getItem("last_name");
  const autoMobile = sessionStorage.getItem("mobile");
  const autoDob = sessionStorage.getItem("done");
  if (autoFirstName && autoLastName && autoMobile && autoDob != null) {
    setName(autoFirstName + " " + autoLastName);
    setMobile(autoMobile);
    setDob(autoDob);
  }

  // Fitness Result
  // const getUserFitnessAge = async () => {
  //   // const baseURL = window.location.href;
  //   // let url = new URL(baseURL);
  //   // let search_params = url.searchParams;
  //   // const id = search_params.get("id");
  //   const res = await getFitnessAge();
  //   setUserDetails(res);
  //   // setPerformanceData(res.execises);
  // };

  //     // Cardio Result
  //     const getCardio = async () => {
  //       // const baseURL = window.location.href;
  //       // let url = new URL(baseURL);
  //       // let search_params = url.searchParams;
  //       // const id = search_params.get("id");
  //       const res = await getCardioHealth(id);
  //       setUserDetails(res);
  //       // setPerformanceData(res.execises);
  //     };

  // // Quick Stretches
  // async function fetchResult() {
  //   const response = await getTrailResult(resultId);
  //   setResult(response.result);
  // }

  // if(window.fitnessResultRedirect = true){

  // }

  // // Auto fill User's Details
  // const urlParams = new URLSearchParams(window.location.search);
  // const firstName = urlParams.get("firstName");
  // const lastName = urlParams.get("lastName");
  // console.log("url Name : " + firstName);
  // const mobileNumber = urlParams.get("mobile");
  // const userDob = urlParams.get("dob");

  // // set to localStorage
  // localStorage.setItem("name", firstName + " " + lastName);
  // localStorage.setItem("mobile", mobileNumber);
  // // localStorage.setItem("dob", "dob");

  // const x = localStorage.getItem()
  // setName(localStorage.getItem("name"));
  // setMobile(localStorage.getItem("mobile"));
  // console.log(setMobile);

  // setDob(localStorage.getItem("dob"));
  // const fullNameField = document.getElementById("full-name");
  // const mobileField = document.getElementById("mobile-number");
  // const dobField = document.getElementById("dob");
  // fullNameField.value = firstName + " " + lastName;
  // mobileField.value = mobileNumber;
  // dobField.value = userDob;

  // useEffect(() => {
  //   const searchParams = new URLSearchParams(window.location.search);
  //   setName(searchParams.get("first_name" + "last_name") || "");
  //   // setLastName(searchParams.get('last_name') || '');
  //   setMobile(searchParams.get("mobile") || "");
  //   setDob(searchParams.get("dob") || "");
  // }, []);

  // const location = useLocation();
  // const searchParams = new URLSearchParams(location.search);
  // const first_Name = params.get("firstName");
  // const last_Name = params.get("lastName");
  // const mobileNumber = params.get("mobile");
  // const userDob = params.get("dob");
  // console.log("url datas : " + first_Name);
  // const { firstName, lastName, mobile, dob } = useParams();
  return (
    <>
      <CustomDialog
        show={showOtp}
        close={() => {
          setShowOtp(false);
        }}
      >
        <Dialog.Panel
          className={`w-full max-w-xl transform overflow-hidden rounded-2xl bg-[#0B0F19] text-left align-middle shadow-xl transition-all`}
        >
          <div className="w-full flex justify-end items-end">
            <IconButton
              icon={ic_close}
              className="shadow-xl flex justify-end"
              onClick={() => setShowOtp(false)}
            />
          </div>
          <OtpVerification
            email={registerThrough == "email" ? email : null}
            mobile={registerThrough == "mobile" ? mobile : null}
            onVerified={() => {
              setShowOtp(false);
              onClickNext();
            }}
          />
        </Dialog.Panel>
      </CustomDialog>

      <CustomDialog show={showCouponApplied} close={() => {}}>
        <Dialog.Panel
          className={`relative w-full max-w-xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all`}
        >
          <img src={congrats} />
          <p className="absolute -translate-x-1/2 -translate-y-1/2 top-1/2  left-1/2 text-center text-3xl font-poppins font-bold">
            <span className="text-5xl">Congratulations</span>
            <br />
            <br />
            You have got extended trail of {extraTrailDays} days
          </p>
          <button
            onClick={async () => {
              setShowCouponApplied(false);
              if (!isRegister) {
                onClickNext();
                return;
              }
              const validEmail = await getEmailExists(email);
              if (validEmail.userFound) {
                toast("User already exists");
              } else {
                if (registerThrough == "social" || !isRegister) {
                  onClickNext();
                } else {
                  if (wasBackPressed) {
                    onClickNext();
                  } else {
                    setShowOtp(true);
                  }
                }
              }
            }}
            className="absolute bottom-5 -translate-x-1/2 left-1/2 max-w-max mt-5 text-white cursor-pointer text-sm rounded bg-primary-purple px-5 py-4"
          >
            Continue
          </button>
        </Dialog.Panel>
      </CustomDialog>
      <Transition appear show={true}>
        <Transition.Child
          as={Fragment}
          enter="transform transition ease-in-out duration-300"
          enterFrom={wasBackPressed ? "-translate-x-full" : "translate-x-full"}
          enterTo={wasBackPressed ? "translate-x-0" : "translate-x-0"}
          leave="transform transition ease-in-out duration-300"
          leaveFrom={wasBackPressed ? "translate-x-0" : "translate-x-0"}
          leaveTo={wasBackPressed ? "-translate-x-full" : "translate-x-full"}
        >
          <div
            className={`w-full transform py-6 text-left align-middle transition-all space-y-5`}
          >
            {isRegister && (
              <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
                <p className="font-medium basis-2/12 text-white text-lg">
                  Name*
                </p>
                <input
                  className="px-4 py-3 md:w-80 md:h-12 h-auto rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700 "
                  placeholder="Name"
                  id="full-name"
                  value={name}
                  onChange={(e) => {
                    if (e.target.value == "") {
                      setName("");
                    } else if (e.target.value.match(/^[A-Za-z]+$/)) {
                      setName(
                        e.target.value
                          .replace(/[^\w\s\][^,\[\]\^]/gi, "")
                          .replace(/[0-9]/g, "")
                      );
                    }
                  }}
                />
              </div>
            )}
            {/* {isRegister && (
              <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
                <p className="font-medium basis-2/12 text-white text-lg">
                  Email
                  {registerThrough == "email"
                    ? // || registerThrough == "social"
                      "*"
                    : ""}
                </p>
                <input
                  className="px-4 py-3 md:w-80 rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700 "
                  placeholder="Email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  disabled={registerThrough == "social"}
                />
              </div>
            )} */}
            {/* {registerThrough === "email" && isRegister && (
              <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
                <p className="font-medium basis-2/12 text-white text-lg">
                  Password*
                </p>
                <div className="px-4 py-3 md:w-80 flex flex-row rounded-lg items-center  border-[1px] bg-transparent border-customGray-700 ">
                  <input
                    className="bg-transparent flex flex-1 placeholder-customGray-700 text-white outline-none"
                    placeholder="Password"
                    value={password}
                    type={passwordInputType}
                    onChange={(e) => {
                      if (e.target.value.length > 0)
                        if (!e.target.value.match(/^[\S]+$/)) {
                          toast("Spaces are not allowed in password");
                        } else {
                          setPassword(e.target.value);
                        }
                      else {
                        setPassword("");
                      }
                    }}
                  />
                  <Icon
                    icon={
                      passwordInputType === "password"
                        ? "akar-icons:eye"
                        : "akar-icons:eye-slashed"
                    }
                    color="#667085"
                    onClick={() => {
                      setPasswordInputType(
                        passwordInputType === "password" ? "text" : "password"
                      );
                    }}
                    className="w-5 h-5"
                  />
                </div>
              </div>
            )} */}
            {isRegister && (
              <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
                <p className="font-medium basis-2/12 text-white text-lg">
                  Mobile*
                  {registerThrough == "mobile" ? "*" : ""}
                </p>
                <input
                  className="px-4 py-3 md:w-80 md:h-12 h-auto rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700 "
                  placeholder="Mobile"
                  id="mobile-number"
                  value={mobile}
                  onChange={(e) => {
                    setMobile(e.target.value);
                  }}
                  type="number"
                  pattern="[0-9]+"
                />
              </div>
            )}
            <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
              <p className="font-medium basis-2/12 text-white text-lg">
                Birthday*
              </p>
              <div className=" md:w-80 md:h-12 h-auto">
                <DatePicker
                  selected={dob}
                  onChange={(date) => setDob(date)}
                  dateFormat="dd/MM/yyyy"
                  allowSameDay={false}
                  endDate={new Date()}
                  maxDate={new Date()}
                  placeholderText="Date of Birth"
                  closeOnScroll={false}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  className="flex flex-1 px-4 w-full py-3 rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700"
                  id="dob"
                />
              </div>
            </div>
            <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
              <p className="font-medium basis-2/12 text-white text-lg">Sex*</p>
              <RadioGroup
                value={gender}
                onChange={setGender}
                className="grid grid-cols-2 w-full md:w-80 md:h-12 h-auto gap-4"
              >
                <RadioGroup.Option value="male">
                  {({ checked }) => (
                    <p
                      className={`${
                        checked
                          ? `bg-new-lightGray text-black `
                          : ` border-[1px] border-customGray-700 text-primary-white`
                      } text-lg font-medium rounded-full text-center px-8 py-2 cursor-pointer`}
                    >
                      Male
                    </p>
                  )}
                </RadioGroup.Option>
                <RadioGroup.Option value="female">
                  {({ checked }) => (
                    <p
                      className={`${
                        checked
                          ? `bg-new-lightGray text-black `
                          : ` border-[1px] border-customGray-700 text-primary-white`
                      } text-lg font-medium rounded-full text-center px-8 py-2 cursor-pointer`}
                    >
                      Female
                    </p>
                  )}
                </RadioGroup.Option>
              </RadioGroup>
            </div>
            <p className="font-medium  text-xs text-[#B7B9B7] capitalize">
              We are inclusive of all gender, it’s for scientific purpose only
            </p>
            <p className="font-bold text-xl text-[#FFFFFF]">BMI</p>
            <p className="font-normal text-xs text-[#B7B9B7]">
              Your BMI is needed to recommend you the workouts best suited for
              your BMI
            </p>
            <div className="flex flex-col md:flex-row mt-4 md:items-center md:space-x-5">
              <p className="font-medium basis-2/12 text-white text-lg">
                Height*
              </p>
              <div className="flex flex-row items-center md:space-x-2">
                {heightUnit == "cm" && (
                  <input
                    className="px-4 py-3 w-24 md:h-12 h-auto rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700 "
                    placeholder={heightUnit}
                    value={height}
                    onChange={(e) => {
                      setHeight(e.target.value);
                    }}
                    type="number"
                  />
                )}
                <div className="flex flex-col md:flex-row w-full gap-5">
                  {heightUnit == "ft" && (
                    <input
                      className="px-4 py-3 w-24 md:h-12 h-auto rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700 "
                      placeholder={"Ft."}
                      value={feet}
                      onChange={(e) => {
                        setFeet(e.target.value);

                        setHeight(
                          (30.48 * e.target.value + inch * 2.54).toFixed(2)
                        );
                      }}
                      type="number"
                    />
                  )}
                  {heightUnit == "ft" && (
                    <input
                      className="px-4 py-3 w-24 md:h-12 h-auto rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700 "
                      placeholder={"Inc."}
                      value={inch}
                      onChange={(e) => {
                        setInch(e.target.value);
                        setHeight(
                          (feet * 30.54 + e.target.value * 2.54).toFixed(2)
                        );
                      }}
                      type="number"
                    />
                  )}
                </div>
                <div className="flex flex-row items-center gap-5 mt-5 md:mt-0">
                  <p
                    className={`${
                      heightUnit == "cm"
                        ? "text-primary-neonGreen"
                        : "text-primary-gray"
                    } font-medium`}
                  >
                    CENT.
                  </p>
                  <Switch
                    checked={heightUnit == "ft"}
                    onChange={(checked) => {
                      if (checked) {
                        setHeightUnit("ft");
                      } else {
                        setHeightUnit("cm");
                      }

                      if (checked) {
                        setFeet(Math.floor(height / 2.54 / 12));
                        setInch(
                          (
                            height / 2.54 -
                            12 * Math.floor(height / 2.54 / 12)
                          ).toFixed(2)
                        );
                      }
                    }}
                    className={`bg-primary-neonGreen
          relative items-center inline-flex h-[20px] w-[35px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
                  >
                    <span
                      aria-hidden="true"
                      className={`${
                        heightUnit == "ft" ? "translate-x-4" : "-translate-x-2"
                      }
            pointer-events-none justify-center items-center  inline-flex h-[24px] w-[24px] transform rounded-full bg-primary-white drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] ring-0 transition duration-200 ease-in-out`}
                    >
                      <span
                        aria-hidden="true"
                        className={`${
                          heightUnit == "ft"
                            ? "translate-x-0"
                            : "-translate-x-0"
                        }
            pointer-events-none inline-block drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] h-[12px] w-[12px] transform rounded-full bg-white  ring-0 transition duration-200 ease-in-out`}
                      />
                    </span>
                  </Switch>

                  <p
                    className={`${
                      heightUnit == "ft"
                        ? "text-primary-neonGreen"
                        : "text-primary-gray"
                    } font-medium`}
                  >
                    FT.
                  </p>
                </div>
              </div>
            </div>
            <div className="flex flex-col md:flex-row mt-4 md:items-center md:space-x-5">
              <p className="font-medium basis-2/12 text-white text-lg">
                Weight*
              </p>
              <div className="flex flex-row items-center md:space-x-4">
                <input
                  className="px-4 py-3 w-24 md:h-12 h-auto rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700 "
                  placeholder={weightUnit}
                  value={weight}
                  onChange={(e) => {
                    setWeight(e.target.value);
                  }}
                  type="number"
                />
                <div className="flex flex-col md:flex-row w-full gap-5"></div>
                <div
                  // className="flex flex-row items-center gap-5 mt-5 md:mt-0"
                  className="flex flex-row items-center gap-5 mt-5 md:mt-0"
                >
                  <p
                    className={`${
                      weightUnit == "KG"
                        ? "text-primary-neonGreen"
                        : "text-primary-gray"
                    } font-medium`}
                  >
                    KG.
                  </p>
                  <Switch
                    checked={weightUnit == "lbs"}
                    onChange={(checked) => {
                      if (checked) {
                        setWeightUnit("lbs");
                      } else {
                        setWeightUnit("KG");
                      }
                      if (checked) {
                        setWeight((weight / 0.453592).toFixed(2));
                      } else {
                        setWeight((weight * 0.453592).toFixed(2));
                      }
                    }}
                    className={`bg-primary-neonGreen
          relative items-center inline-flex h-[20px] w-[35px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
                  >
                    <span
                      aria-hidden="true"
                      className={`${
                        weightUnit == "lbs" ? "translate-x-4" : "-translate-x-2"
                      }
            pointer-events-none justify-center items-center  inline-flex h-[24px] w-[24px] transform rounded-full bg-primary-white drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] ring-0 transition duration-200 ease-in-out`}
                    >
                      <span
                        aria-hidden="true"
                        className={`${
                          weightUnit == "lbs"
                            ? "translate-x-0"
                            : "-translate-x-0"
                        }
            pointer-events-none inline-block drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] h-[12px] w-[12px] transform rounded-full bg-white  ring-0 transition duration-200 ease-in-out`}
                      />
                    </span>
                  </Switch>
                  <p
                    className={`${
                      weightUnit == "lbs"
                        ? "text-primary-neonGreen"
                        : "text-primary-gray"
                    } font-medium`}
                  >
                    LBS.
                  </p>
                </div>
              </div>
            </div>
            {weight && height && dob ? (
              <div className="flex flex-row space-x-10 font-open-sans">
                <p className="text-xl font-bold text-[#FFFFFF]">
                  BMI = {bmi}
                  {"   "}
                  <span className="text-[#C3F73A] font-normal">
                    {" "}
                    {getHealthCondition()}
                  </span>
                </p>
                <p className="text-xl font-bold text-[#FFFFFF]">
                  BMR = {bmr}
                  {"   "}
                  <span className="text-[#C3F73A] font-normal">
                    {" "}
                    Kcal
                    {/* {healthStatus} */}
                  </span>
                </p>
              </div>
            ) : (
              ""
            )}

            <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
              <p className="font-medium basis-2/12 text-white text-lg">
                Coupon{" "}
              </p>
              <input
                className="px-4 py-3 md:w-80 md:h-12 h-auto rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700 "
                placeholder="Coupon"
                value={coupon}
                onChange={(e) => {
                  setCoupon(e.target.value);
                }}
              />
            </div>
            {isRegister && (
              <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
                <p className="font-medium basis-2/12 text-white text-lg">
                  Email
                </p>
                <input
                  className="px-4 py-3 md:w-80 md:h-12 h-auto rounded-lg border-[1px] placeholder-[#BABABD] placeholder-xs text-xs text-white bg-transparent border-customGray-700 "
                  placeholder="Receive performance reports directly to your inbox"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />
              </div>
            )}

            <div className="flex justify-end">
              <div
                className="max-w-max mt-5 text-white cursor-pointer text-sm rounded bg-primary-purple px-10 py-4"
                onClick={async () => {
                  if (!name && isRegister) {
                    toast("Name is required", { type: "error" });
                  }
                  // else if (email === "") {
                  //   setEmail("");
                  // }
                  // else if (!validateEmail(email)) {
                  //   toast("Invalid email", { type: "error" });
                  // }
                  // else if (
                  //   !validateEmail(email) &&
                  //   isRegister &&
                  //   email?.length > 0
                  // ) {
                  //   toast("Invalid email", { type: "error" });
                  // }
                  else if (
                    !validPhone(mobile) &&
                    isRegister &&
                    registerThrough == "mobile"
                  ) {
                    toast("Invalid mobile", { type: "error" });
                  } else if (!validPhone(mobile) && isRegister && mobile) {
                    toast("Invalid mobile", { type: "error" });
                  }
                  // else if (
                  //   !password &&
                  //   registerThrough === "email" &&
                  //   isRegister
                  // ) {
                  //   toast("Password is required", { type: "error" });
                  // } else if (
                  //   registerThrough === "email" &&
                  //   password?.length < 8 &&
                  //   isRegister
                  // ) {
                  //   toast("Password should be at least 8 characters", {
                  //     type: "error",
                  //   });
                  // }
                  else if (dob == null) {
                    toast("Date of Birth is required", { type: "error" });
                  } else if (!gender) {
                    toast("Gender is required", { type: "error" });
                  } else if (!height || height < 0) {
                    toast("Height is required", { type: "error" });
                  } else if (
                    heightUnit != "cm" &&
                    (feet < 2 || feet > 7 || inch < 5 || inch > 5)
                  ) {
                    toast("Height must be between 3.5 ft.to 7.5 ft.", {
                      type: "error",
                    });
                  } else if (
                    heightUnit != "ft" &&
                    (height < 106 || height > 228)
                  ) {
                    toast("Height must be between 106 cm to 228 cm.", {
                      type: "error",
                    });
                  } else if (!weight) {
                    toast("Weight is required", { type: "error" });
                  }
                  // else if (weight <= 1) {
                  //   toast("Weight must be between 20 kg to 150", { type: "error" });
                  // }
                  else if (
                    weightUnit == "lbs" &&
                    (weight < 66 || weight > 385)
                  ) {
                    toast("Weight must be between 66 and 385 lbs.", {
                      type: "error",
                    });
                  } else if (
                    weightUnit != "lbs" &&
                    (weight < 30 || weight > 175)
                  ) {
                    toast("Weight must be between 30 and 175 kgs.", {
                      type: "error",
                    });
                  } else {
                    if (!isRegister) {
                      onClickNext();
                      return;
                    }

                    if (coupon.length > 0) {
                      const response = await getCouponDetails(coupon);
                      if (!response?.success) {
                        toast(response.message, { type: "error" });
                        return;
                      } else {
                        setExtraTrailDays(response.credit);
                        setShowCouponApplied(true);

                        return;
                      }
                    }
                    const validEmail = await getEmailExists(email);
                    if (validEmail.userFound) {
                      toast("User already exists");
                    } else {
                      if (registerThrough == "social" || !isRegister) {
                        onClickNext();
                      } else {
                        if (wasBackPressed) {
                          onClickNext();
                        } else {
                          setShowOtp(true);
                        }
                      }
                    }
                  }
                }}
                type="primary"
              >
                FINISH
              </div>
            </div>
          </div>
        </Transition.Child>
      </Transition>
    </>
  );
}

export function RegistrationStep2({
  describes,
  setDescribes,
  wasBackPressed,
  onClickNext,
  onClickBack,
}) {
  const list = [
    {
      title: "Lose Weight",
      value: "lose_weight",
      image: "https://getactyvfitness.blob.core.windows.net/images/0.75x/Artboard+2+copy%400.75x-8.png",
    },
    {
      title: "Get Fitter",
      value: "fitter_me",
      image: "https://getactyvfitness.blob.core.windows.net/images/exercises/tabata.jpg",
    },
    {
      title: "Gain Strength",
      value: "gain_strength",
      image:
        "https://getactyvfitness.blob.core.windows.net/images/0.75x/Artboard+2+copy+7%400.75x-8.png",
    },
    {
      title: "Gain Flexibility",
      value: "flexibility",
      image:
        "https://getactyvfitness.blob.core.windows.net/images/0.75x/Artboard+2+copy+4%400.75x-8.png",
    },
    {
      title: "Beat the Stress",
      value: "stress_buster",
      image:
        "https://getactyvfitness.blob.core.windows.net/images/0.75x/Artboard+2+copy+6%400.75x-8.png",
    },
    {
      title: "Walk: Fitness for walkers",
      value: "walk",
      image: "https://getactyvfitness.blob.core.windows.net/images/exercises/total.jpg",
    },
    {
      title: "Run: Fitness for Runners",
      value: "run",
      image: "https://getactyvfitness.blob.core.windows.net/images/exercises/speed.jpg",
    },
    {
      title: "Cycle: Fitness for Cyclists",
      value: "cycle",
      image: "https://getactyvfitness.blob.core.windows.net/images/exercises/play.jpg",
    },
    {
      title: "Football: Up my game",
      value: "football",
      image: "https://getactyvfitness.blob.core.windows.net/images/exercises/football.jpg",
    },
    {
      title: "Basketball: Up my game",
      value: "basketball",
      image: "https://getactyvfitness.blob.core.windows.net/images/exercises/basketball.jpg",
    },
    {
      title: "Tennis: Up my game",
      value: "tennis",
      image: "https://getactyvfitness.blob.core.windows.net/images/exercises/tennis.jpg",
    },
    {
      title: "Cricket: Up my game",
      value: "cricket",
      image: "https://getactyvfitness.blob.core.windows.net/images/exercises/cricket.jpg",
    },
    {
      title: "Badminton: Up my game",
      value: "badminton",
      image: "https://getactyvfitness.blob.core.windows.net/images/exercises/batmeton.jpg",
    },
  ];

  function Item({ title, image, selection, selectionIndex, onClick }) {
    return (
      <div
        className={`bg-[#181822] rounded-xl hover:cursor-pointer w-full h-full overflow-clip`}
        onClick={onClick}
      >
        <div className="relative rounded-xl overflow-clip">
          {selectionIndex > -1 && (
            <div className="absolute bg-[#FE654F99] w-full h-full flex justify-center items-center">
              <p className="text-6xl text-center text-white font-bold">
                {selectionIndex + 1}
              </p>
            </div>
          )}
          <img
            src={image}
            className="max-h-40 w-full object-cover rounded-xl"
          />
        </div>
        <p className={`p-2 text-white font-medium`}>{title}</p>
      </div>
    );
  }
  console.log("RENDING STEP 2");
  return (
    <Transition appear show={true}>
      <Transition.Child
        as={Fragment}
        enter="transform transition ease-in-out duration-300"
        enterFrom={wasBackPressed ? "-translate-x-full" : "translate-x-full"}
        enterTo={wasBackPressed ? "translate-x-0" : "translate-x-0"}
        leave="transform transition ease-in-out duration-300"
        leaveFrom={wasBackPressed ? "translate-x-0" : "translate-x-0"}
        leaveTo={wasBackPressed ? "-translate-x-full" : "translate-x-full"}
      >
        <div className={`w-full transform py-10`}>
          <p className="text-white text-xl">
            Select any 3 goals{" "}
            <span className="text-primary-orange font-bold">
              ({describes.length}/3 selected)
            </span>
          </p>
          <div className="mt-5 grid grid-cols-1 md:grid-cols-4 gap-5">
            {list.map((goal) => {
              return (
                <Item
                  {...goal}
                  selection={describes.includes(goal.value)}
                  selectionIndex={describes.indexOf(goal.value)}
                  onClick={() => {
                    if (describes.includes(goal.value)) {
                      let list = [];
                      describes.forEach((eid) => {
                        if (eid != goal.value) {
                          list.push(eid);
                        }
                      });
                      setDescribes([...list]);
                    } else {
                      if (describes.length > 2) {
                        toast("You have already selected 3 priorities");
                      } else {
                        setDescribes([...describes, goal.value]);
                      }
                    }
                  }}
                />
              );
            })}
          </div>
          <div className="flex justify-center space-x-10">
            <div
              className="max-w-max mt-5 text-white cursor-pointer text-sm rounded border-[1px] border-customGray-700 px-5 py-4"
              onClick={() => {
                onClickBack();
              }}
            >
              GO BACK
            </div>
            <div className="flex flex-1" />
            <div
              className="max-w-max mt-5 text-white cursor-pointer text-sm rounded bg-primary-purple px-5 py-4"
              onClick={async () => {
                if (describes.length != 3) {
                  toast("Please select three goals", { type: "error" });
                } else {
                  onClickNext();
                }
              }}
            >
              NEXT
            </div>
          </div>
        </div>
      </Transition.Child>
    </Transition>
  );
}

export function RegistrationStep3({
  answers,
  setAnswers,
  onClickNext,
  injuries,
  otherInjuries,
  setOtherInjuries,
  setInjuries,
  workoutDuration,
  setWorkoutDuration,
  onClickBack,
  wasBackPressed,
}) {
  const questions = [
    {
      questionNormal: "How ",
      questionBold: "long have you been training/working out?",
      key: "workingOutFrom",
      options: [
        {
          value: "Not Started",
          key: 1,
        },
        {
          value: "1-6 months",
          key: 2,
        },
        {
          value: "6-12 months",
          key: 3,
        },
        {
          value: "1-2 years",
          key: 4,
        },
        {
          value: "More than 2 years",
          key: 5,
        },
      ],
    },
    {
      questionNormal: "When was the",
      questionBold: "last time you trained?",
      key: "lastWorkedOut",

      options: [
        {
          value: "This Week",
          key: 1,
        },
        {
          value: "It's been a month",
          key: 2,
        },
        {
          value: "It's been more than 6 months",
          key: 3,
        },
      ],
    },
    {
      questionNormal: "Do you have any of the following injuries?",
      options: [
        {
          value: "Knee Pain",
          key: "knee Pain",
        },
        {
          value: "Wrist/Fore arm Pain",
          key: "Wrist/Fore arm Pain",
        },
        {
          value: "Neck and Shoulder Pain",
          key: "Neck and Shoulder Pain",
        },
        {
          value: "Lower back issues",
          key: "Lower back issues",
        },
        {
          value: "Ankle Pain",
          key: "Ankle Pain",
        },
        {
          value: "None",
          key: "none",
        },
      ],
    },
    {
      questionNormal: "How did you hear about us?",
      key: "refer",
      options: [
        {
          value: "Facebook",
          key: "facebook",
        },
        {
          value: "Instagram",
          key: "instagram",
        },
        {
          value: "Youtube",
          key: "youtube",
        },
        {
          value: "Twitter",
          key: "twitter",
        },
        {
          value: "Friends",
          key: "friends",
        },
        {
          value: "Trainer",
          key: "trainer",
        },
      ],
    },
  ];
  function Question({
    questionNormal,
    questionBold,
    options,
    index,
    answer,
    setAnswer,
  }) {
    return (
      <div className=" flex flex-col">
        <p className="text-lg text-white">
          {questionNormal} <span className="font-bold">{questionBold}</span>
        </p>
        <Popover className={"relative w-full md:w-1/2 mt-5 "}>
          <Popover.Button
            className={`flex flex-row w-full  space-x-2 text-white border-[1px] border-customGray-700 rounded-lg items-center px-5 py-2`}
          >
            <p className="text-xl w-full text-left z-0">
              {answer
                ? options.find((element) => element.key == answer).value
                : "SELECT"}
            </p>
            <Icon
              icon={"akar-icons:chevron-down"}
              className="text-primary-white"
            />
          </Popover.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-150"
            enterFrom="opacity-0 translate-y-0"
            enterTo="opacity-100 translate-y-1"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-1"
            leaveTo="opacity-0 translate-y-0"
          >
            <Popover.Panel
              className={`absolute z-50 w-full  -mt-1  p-4 space-y-2 flex flex-col ${WhiteLinearGradientDarkPlain} rounded-xl`}
            >
              {({ close }) => (
                <>
                  {options.map((option) => {
                    return (
                      <p
                        className="font-bold cursor-pointer"
                        onClick={() => {
                          setAnswer(option.key);
                          close();
                        }}
                      >
                        {option.value}
                      </p>
                    );
                  })}
                </>
              )}
            </Popover.Panel>
          </Transition>
        </Popover>
      </div>
    );
  }

  return (
    <Transition show={true}>
      <Transition.Child
        as={Fragment}
        enter="transform transition ease-in-out duration-300"
        enterFrom={wasBackPressed ? "-translate-x-full" : "translate-x-full"}
        enterTo={wasBackPressed ? "translate-x-0" : "translate-x-0"}
        leave="transform transition ease-in-out duration-300"
        leaveFrom={wasBackPressed ? "translate-x-0" : "translate-x-0"}
        leaveTo={wasBackPressed ? "-translate-x-full" : "translate-x-full"}
      >
        <div className="py-10">
          <div className=" grid grid-cols-1 md:grid-cols-2 gap-5 w-full transition-all transform">
            <Question
              {...questions[0]}
              answer={answers[questions[0].key]}
              setAnswer={(answer) => {
                let ans = { ...answers };
                ans[questions[0].key] = answer;
                setAnswers(ans);
              }}
            />
            <Question
              {...questions[1]}
              answer={answers[questions[1].key]}
              setAnswer={(answer) => {
                let ans = { ...answers };
                ans[questions[1].key] = answer;
                setAnswers(ans);
              }}
            />

            <div>
              <p className="text-lg text-white">
                Do you have any of the following injuries?
              </p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
                {questions[2].options.map((option) => {
                  return (
                    <div
                      className="cursor-pointer flex flex-row space-x-3 justify-start items-center"
                      onClick={() => {
                        let list = [];
                        if (option.key == "none") {
                          setInjuries(["none"]);
                        } else {
                          injuries.forEach((optionKey) => {
                            if (optionKey != "none") {
                              list.push(optionKey);
                            }
                          });
                          if (list.includes(option.key)) {
                            let l = [];
                            list.forEach((optionKey) => {
                              if (optionKey != option.key) {
                                l.push(optionKey);
                              }
                            });
                            setInjuries([...l]);
                          } else {
                            setInjuries([...list, option.key]);
                          }
                        }
                      }}
                    >
                      <div
                        className={`${
                          injuries.includes(option.key)
                            ? `bg-primary-blue  `
                            : `bg-slate-400`
                        }  rounded-md w-5 h-5 object-cover`}
                      />
                      <p className={`font-medium flex flex-1 text-white`}>
                        {option.value}
                      </p>
                    </div>
                  );
                })}
                <div className="flex flex-col md:flex-row  md:items-center md:space-x-5">
                  <input
                    className="px-4 py-3 md:w-80 rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700 "
                    placeholder="Other Injuries"
                    value={otherInjuries}
                    onChange={(e) => {
                      if (e.target.value == "") {
                        setOtherInjuries("");
                      } else if (e.target.value.match(/^[A-Za-z ]+$/)) {
                        setOtherInjuries(
                          e.target.value
                            .replace(/[^\w\s\][^,\[\]\^]/gi, "")
                            .replace(/[0-9]/g, "")
                        );
                      }
                    }}
                  />
                </div>
              </div>
            </div>
            <Question
              {...questions[3]}
              answer={answers[questions[3].key]}
              setAnswer={(answer) => {
                let ans = { ...answers };
                ans[questions[3].key] = answer;
                setAnswers(ans);
              }}
            />
          </div>
          <div className="mt-10">
            <p className="text-lg text-white">
              When you do,{" "}
              <span className="font-bold">
                how often do you workout in a week?
              </span>
            </p>
            <div className="relative md:w-1/2">
              <Range
                aria-label="Workout Duration"
                step={1}
                min={0}
                max={7}
                values={workoutDuration}
                onChange={(values) => {
                  setWorkoutDuration(values);
                }}
                renderTrack={({ props, children }) => (
                  <div
                    {...props}
                    style={{
                      ...props.style,
                      background: getTrackBackground({
                        values: workoutDuration,
                        colors: ["#0B28AC", "#6376CD"],
                        min: 0,
                        max: 7,
                      }),
                      cursor: "pointer",
                    }}
                    className="w-full h-2 mt-12 rounded-full "
                  >
                    {children}
                  </div>
                )}
                renderThumb={({ props }) => (
                  <div
                    aria-label="meeting minutes thumb"
                    {...props}
                    style={{
                      ...props.style,
                      outline: "none",
                      cursor: "pointer",
                    }}
                    className={`flex justify-center`}
                  >
                    <p
                      className={`ml-20 font-bold text-center bg-primary-midBlack w-48 rounded-full px-4 py-2 -mt-2 text-white self-center absolute -top-8`}
                    >
                      {numberToWords(workoutDuration[0])}
                      {workoutDuration[0] > 1 ? " Days " : " Day "} a week
                    </p>
                    <span
                      aria-hidden="true"
                      className={`
            pointer-events-none justify-center items-center  inline-flex h-[24px] w-[24px] transform rounded-full bg-primary-white drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] ring-0 transition duration-200 ease-in-out`}
                    >
                      <span
                        aria-hidden="true"
                        className={`
            pointer-events-none inline-block drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] h-[12px] w-[12px] transform rounded-full bg-white  ring-0 transition duration-200 ease-in-out`}
                      />
                    </span>
                  </div>
                )}
              />
            </div>
          </div>
          <div />
          <div className="flex justify-center space-x-10 mt-10">
            <div
              className="max-w-max mt-5 text-white cursor-pointer text-sm rounded border-[1px] border-customGray-700 px-5 py-4"
              onClick={() => {
                onClickBack();
              }}
            >
              GO BACK
            </div>
            <div className="flex flex-1" />
            <div
              className="max-w-max mt-5 text-white cursor-pointer text-sm rounded bg-primary-purple px-5 py-4"
              onClick={async () => {
                if (answers.workingOutFrom.length == 0) {
                  toast(
                    "Please share how long have you been training/working out",
                    {
                      type: "error",
                    }
                  );
                } else if (answers.lastWorkedOut.length == 0) {
                  toast("Please share when was the last time you trained", {
                    type: "error",
                  });
                } else if (injuries.length <= 0) {
                  toast("Please share if you have any injuries", {
                    type: "error",
                  });
                } else if (answers.refer.length == 0) {
                  toast("Please share how did you hear about us", {
                    type: "error",
                  });
                } else {
                  onClickNext();
                }
              }}
            >
              CREATE PROGRAMS
            </div>
          </div>
        </div>
      </Transition.Child>
    </Transition>
  );
}

function RegisterPage() {
  const location = useLocation();
  const [step, setStep] = useState(0);
  const [name, setName] = useState(location.state?.fullname);
  const [email, setEmail] = useState(location.state?.email);
  const [mobile, setMobile] = useState(location.state?.phone);
  const [password, setPassword] = useState();
  const [height, setHeight] = useState();
  const [weight, setWeight] = useState();
  const [gender, setGender] = useState();
  const [dob, setDob] = useState();
  const [heightUnit, setHeightUnit] = useState("cm");
  const [weightUnit, setWeightUnit] = useState("KG");
  const [workoutGoal, setWorkoutGoal] = useState([]);
  const [workoutDuration, setWorkoutDuration] = useState([0]);
  const [injuries, setInjuries] = useState([]);
  const [answers, setAnswers] = useState({
    workingOutFrom: "",
    lastWorkedOut: "",
    refer: "",
  });
  const [otherInjuries, setOtherInjuries] = useState("");
  const [coupon, setCoupon] = useState("");
  const registerThrough = location.state?.registerThrough || "mobile";

  const navigate = useNavigate();
  const auth = useAuthContext();

  const utm_url = sessionStorage.getItem("utm_url") || null;

  async function register() {
    let user = {
      fullname: name,
      email: email ? email : "",
      height: height,
      weight: weight,
      workoutWeekDuration: workoutDuration[0],
      workoutGoal: workoutGoal,
      dob: dob
        .toLocaleString("en-us", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .replace(/(\d+)\/(\d+)\/(\d+)/, "$2/$1/$3"),
      gender: gender,
      hasInjury: injuries.includes("none") ? 0 : 1,
      injuries: injuries.includes("none")
        ? []
        : otherInjuries != ""
        ? [...injuries, otherInjuries]
        : injuries,
      refer: answers.refer,
      lastWorkedOut: answers.lastWorkedOut,
      workingOutFrom: answers.workingOutFrom,
      verifiedThrough: registerThrough,
      mobile: mobile ? "+91" + mobile : "",
      coupon: coupon,
      utm_url: utm_url,
    };
    if (location.state?.socialLogin) {
      user = { ...location.state, ...user };
    } else {
      // user.password = password;
    }
    console.log(user);
    const response = await auth.register(user);
    if (response.success) {
      toast("Registration Successful", { type: "success" });
      // createProgram();
      // navigate("/programpage");
      navigate("/registration_Complete");
    } else {
      toast(response.msg, { type: "error" });
    }
  }

  const createProgram = async () => {
    setShowCurationDialog(true);

    let detials = {
      goals: JSON.stringify(workoutGoal),
      workingOutFrom: answers.workingOutFrom,
      lastTimeWorkedOut: answers.lastWorkedOut,
    };
    await createUserProgram(detials);
    setTimeout(async () => {
      await auth.updateUser();
      setShowCurationDialog(false);
      navigate("/programpage");
    }, 3000);
  };

  const [showCuratingDialog, setShowCurationDialog] = useState(false);
  const [wasBackPressed, setWasBackPressed] = useState(false);

  // if (auth.state.user) {
  //   navigate("/exercise");
  //   return;
  // }

  useEffect(() => {
    if (location.state && location.state?.phone != mobile) {
      setMobile(location.state.phone);
    }
    if (location.state && location.state?.email != email) {
      setEmail(location.state.email);
    }
  }, [location.state]);

  // // set to localStorage
  // localStorage.setItem("name", "firstname" + "lastname");
  // localStorage.setItem("mobile", "mobile");
  // localStorage.setItem("dob", "dob");

  // // const x = localStorage.getItem()
  // setName(localStorage.getItem("name"));
  // setMobile(localStorage.getItem("mobile"));
  // setDob(localStorage.getItem("dob"));

  return (
    <div
      className={`font-open-sans w-full h-full px-6 py-10 md:px-16 lg:px-24 2xl:px-32 `}
      id="register"
    >
      <CuratingPlaylist show={showCuratingDialog} closeDialog={() => {}} />
      <div className="bg-white bg-opacity-5 rounded-lg overflow-clip">
        <div
          className="p-6 md:p-10 bg-no-repeat overflow-clip"
          style={{ backgroundImage: `url(${healthyLife})` }}
        >
          <p className="font-poppins text-white font-bold text-3xl md:text-4xl leading-snug">
            <span className="text-primary-neonGreen">Create</span> Your Account
          </p>
          <p
            className={`text-white text-opacity-70 mt-2 mb-7 text-lg font-medium `}
          >
            Tell us more about you
          </p>

          {/* <Stepper maxStep={2} currentStep={step} /> */}
        </div>
        <div className="px-6 md:px-14">
          {step == 0 && (
            <RegistrationStep1
              wasBackPressed={wasBackPressed}
              isRegister={true}
              setStep={setStep}
              name={name}
              setName={setName}
              email={email}
              setEmail={setEmail}
              mobile={mobile}
              setMobile={setMobile}
              password={password}
              setPassword={setPassword}
              height={height}
              setHeight={setHeight}
              weight={weight}
              setWeight={setWeight}
              dob={dob}
              setDob={setDob}
              heightUnit={heightUnit}
              setHeightUnit={setHeightUnit}
              weightUnit={weightUnit}
              setWeightUnit={setWeightUnit}
              gender={gender}
              setGender={setGender}
              coupon={coupon}
              setCoupon={setCoupon}
              onClickNext={() => {
                setWasBackPressed(false);
                register();
              }}
              // onClickBack={() => {
              //   setWasBackPressed(true);
              //   document
              //     .getElementById("register")
              //     .scrollIntoView({ behavior: "smooth" });
              //   setStep(0);
              // }}
              registerThrough={registerThrough}
            />
          )}
          {/* {step == 1 && (
            <RegistrationStep2
              wasBackPressed={wasBackPressed}
              describes={workoutGoal}
              setDescribes={setWorkoutGoal}
              onClickNext={() => {
                setWasBackPressed(false);
                document
                  .getElementById("register")
                  .scrollIntoView({ behavior: "smooth" });
                setStep(2);
              }}
              onClickBack={() => {
                setWasBackPressed(true);
                document
                  .getElementById("register")
                  .scrollIntoView({ behavior: "smooth" });
                setStep(0);
              }}
            />
          )}

          {step == 2 && (
            <RegistrationStep3
              answers={answers}
              setAnswers={setAnswers}
              injuries={injuries}
              setInjuries={setInjuries}
              workoutDuration={workoutDuration}
              setWorkoutDuration={setWorkoutDuration}
              otherInjuries={otherInjuries}
              setOtherInjuries={setOtherInjuries}
              onClickNext={() => {
                setWasBackPressed(false);
                register();
              }}
              onClickBack={() => {
                setWasBackPressed(true);
                document
                  .getElementById("register")
                  .scrollIntoView({ behavior: "smooth" });
                setStep(1);
              }}
            />
          )} */}
        </div>
      </div>
    </div>
  );
}

export default RegisterPage;
